import { Cpu32BitIcon } from './Cpu32BitIcon';

/**
 * author: GreenTurtwig
 * id BC9DA934-ED6D-4EC4-9FA4-2B6FF26B3058
 * name cpu-32-bit
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cpu-32-bit.svg
 * tags
 */
export const Chip32BitIcon = Cpu32BitIcon;
export default Chip32BitIcon